<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false">


            <Form ref="formValidate" :model="params" :rules="ruleValidate" :label-width="120">
                <FormItem label="名称：" prop="warehouseName">
                    <Input maxlength="128" v-model.trim="params.warehouseName" placeholder="请输入仓库名称"></Input>
                </FormItem>
                <FormItem label="省/市/区：" prop="regionId">
<!--                    <Input v-model.trim="params.province" placeholder="请输入省"></Input>-->
                  <Cascader
                      v-model="selectedArea"
                      :data="areaData"
                      placeholder="请选择省市区"
                      change-on-select
                      @on-change="handleCascaderChange"
                  ></Cascader>
                </FormItem>
<!--                <FormItem label="市：" prop="city">-->
<!--                    <Input v-model.trim="params.city" placeholder="请输入市"></Input>-->
<!--                </FormItem>-->
<!--                <FormItem label="区：" prop="county">-->
<!--                    <Input v-model.trim="params.county" placeholder="请输入区"></Input>-->
<!--                </FormItem>-->
                <FormItem label="地址：" prop="address">
                    <Input v-model.trim="params.address" placeholder="请输入地址"></Input>
                </FormItem>
                <FormItem label="联系人：" prop="contact">
                    <Input v-model.trim="params.contact" placeholder="请输入联系人"></Input>
                </FormItem>
                <FormItem label="手机号：" prop="mobile">
                    <Input v-model.trim="params.mobile" placeholder="请输入手机号"></Input>
                </FormItem>
            </Form>


            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button v-if="type != 1" type="primary" @click="handleSubmit('formValidate')" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "warehouse-ope",
        props: ['areaData'],
        data() {
            return {
                isShowModal: false,
                loadingBtn: false,
                title: '查看仓库信息',
                type: 0,
                selectedArea: [],
                params: {
                    warehouseId: '',
                    warehouseName: '',
                    province: '',
                    city: '',
                    county: '',
                    address: '',
                    contact: '',
                    mobile: '',
                    regionId: ''
                },
                ruleValidate: {
                    warehouseName: [
                        {required: true, message: '仓库名称不能为空', trigger: 'change'},
                        {max: 128, message: '仓库名称过长', trigger: 'change'}
                    ],
                    address: [
                        {required: true, message: '地址不能为空', trigger: 'change'}
                    ],
                    contact: [
                        {required: true, message: '联系人不能为空', trigger: 'change'}
                    ],
                    mobile: [
                        {required: true, message: '手机号不能为空', trigger: 'change'}
                    ],
                }
            }
        },
        methods: {
          handleCascaderChange(value, selectedData) {
            console.log(value, selectedData);
            this.params.regionId = value[value.length - 1];
          },
            // 点击提交验证
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        /**
                         * type判断
                         * 1.查看 2.新增 3.编辑
                         */
                        switch (this.type) {
                            case 1:
                                break;
                            case 2:
                                // 新增仓库
                                this.addWarehouse();
                                break;
                            case 3:
                                // 编辑仓库
                                this.updateWarehouse();
                                break;
                            default:
                                this.$Notice.error({
                                    title: '仓库管理',
                                    desc: '查看，新增，编辑区分判断报错',
                                    duration: 0
                                });
                                break
                        }
                    } else {
                        this.$Message.error('还有信息没有填写合格哦~');
                    }
                })
            },
            // 显示模态框
            show(type, row) {
                this.isShowModal = true;
                this.type = type;
                /**
                 * type判断
                 * 1.查看 2.新增 3.编辑
                 */
                switch (type) {
                    case 1:
                        this.title = '查看仓库信息';
                        this.findWarehouseById(row);
                        break;
                    case 2:
                        this.title = '新增仓库';
                        break;
                    case 3:
                        this.title = '编辑仓库';
                        this.findWarehouseById(row);
                        break;
                    default:
                        this.$Notice.error({
                            title: '仓库管理',
                            desc: '查看，新增，编辑模态框报错',
                            duration: 0
                        });
                        break
                }
            },
            // 新增仓库
            addWarehouse() {
                this.$Spin.show();
                this.axios.post('/warehouse/add', this.params).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.$emit('changeDate');
                        this.$Message.success('操作成功.');
                        this.hide('formValidate');
                    }
                    if(res.status == 201){
                        this.$Message.error(res.msg);
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '新增仓库接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 编辑仓库
            updateWarehouse(){
                this.$Spin.show();
                this.axios.post('/warehouse/update', this.params).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.$emit('changeDate');
                        this.$Message.success('操作成功.');
                        this.hide('formValidate');
                    }
                    if(res.status == 201){
                        this.$Message.error(res.msg);
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '编辑仓库接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 查询仓库详情
            findWarehouseById(row){
                this.$Spin.show();
                this.axios.post('/warehouse/getById', {
                    warehouseId: row.warehouseId
                }).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.params.warehouseId = res.data.warehouseId;
                        this.params.warehouseName = res.data.warehouseName;
                        this.params.address = res.data.address;
                        this.params.contact = res.data.contact;
                        this.params.mobile = res.data.mobile;
                        this.params.regionId = res.data.regionId;
                        this.selectedArea = [res.data.provinceCode, res.data.cityCode, res.data.countyCode];
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查看仓库详情接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 关闭模态框
            hide(name) {
                this.isShowModal = false;
                this.params.warehouseId = '';
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>

</style>